import { Typography, makeStyles } from '@material-ui/core'
import { Skeleton } from '@material-ui/lab'
import React, { useEffect } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useHistory } from 'react-router-dom'
import { useActionRunner } from '../../../../notification'
import { usePurchasing } from '../../purchasing'
import { useRecipes } from '../hooks'
import RecipeCard from './RecipeCard'
import { sortBy } from 'lodash'

const useStyles = makeStyles(theme => ({
  countLabel: {
    display: 'none',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.up('tablet')]: {
      display: 'block',
    },
  },
  supplierCard: {
    marginBottom: theme.spacing(2),
  },
}))

const RecipeList = ({ hasNextPage, onFetchMore, suppliers, ...props }) => {
  const {
    fetchRecipes,
    recipes,
    menuFilterChoices,
    categoryFilterChoices,
    search,
  } = useRecipes()
  const { purchasingEnvironment } = usePurchasing()
  const history = useHistory()

  const [doFetchRecipes, isFetching] = useActionRunner(fetchRecipes, {
    initialFetchingState: true,
  })

  useEffect(() => {
    doFetchRecipes({ purchasingEnvironment, search })
  }, [])

  useEffect(() => {
    doFetchRecipes({
      purchasingEnvironment,
      menuFilterChoices,
      categoryFilterChoices,
      search,
    })
  }, [menuFilterChoices, purchasingEnvironment, categoryFilterChoices, search])

  const total = recipes.length

  const classes = useStyles()

  const showingText = `Showing ${total} ${total === 1 ? 'recipe' : 'recipes'}`

  const onClick = id => {
    history.push(`/recipes/detail/${id}`)
  }

  return (
    <div>
      {!isFetching ? (
        <>
          <Typography
            className={classes.countLabel}
            variant="body2"
            color="textSecondary"
          >
            {showingText}
          </Typography>

          <InfiniteScroll
            dataLength={suppliers.length}
            next={onFetchMore}
            hasMore={hasNextPage}
          >
            {sortBy(recipes, ['name']).map(recipe => (
              <RecipeCard
                {...recipe}
                purchasingEnvironment={purchasingEnvironment}
                className={classes.supplierCard}
                key={recipe.id}
                onClick={() => onClick(recipe.id)}
                {...props}
              />
            ))}
          </InfiniteScroll>
        </>
      ) : (
        [1, 2, 3].map(() => (
          <Skeleton
            variant="rect"
            height={150}
            style={{
              borderRadius: 10,
              marginTop: 10,
              marginBottom: 9,
            }}
          />
        ))
      )}
    </div>
  )
}

RecipeList.defaultProps = {
  hasNextPage: false,
  suppliers: [],
  total: 0,
}

export default RecipeList
